<div class="flex justify-between">
    <h1 class="text-3xl ps-4 first-letter:capitalize">
        {{ "DASHBOARD.PRODUCT_HANDLING.NEW_PRODUCT" | translate }}
    </h1>
</div>



<form #form [formGroup]="productForm" class="bg-slate-100 h-full m-4" (submit)="onSubmit()">

    <div class="bg-primary text-white p-4 font-bold">
        {{ "DASHBOARD.PRODUCT_HANDLING.GENERIC_PRODUCT_SETTINGS" | translate }}
    </div>

    <div class="grid grid-cols-[repeat(auto-fit,minmax(20rem,1fr))] gap-4 p-4">
        <app-card-wrap layout="col">

            <label for="name" class="flex flex-col space-x-4">
                <span class="font-bold">{{ "DASHBOARD.PRODUCT_HANDLING.PRODUCT_NAME" | translate }}</span>
                <app-input
                        id="name"
                        type="text"
                        placeholder=""
                        [formController]="productForm.controls.name"
                        [initialValue]="productForm.controls.name.value"
                />
                @if (this.submitAction() && !productForm.controls.name.valid) {
                    <span class="text-red-500">{{ "DASHBOARD.PRODUCT_HANDLING.PRODUCT_NAME_REQUIRED" | translate }}</span>
                }
            </label>

            <label for="product-code" class="flex flex-col space-x-4">
                <span class="font-bold">{{ "DASHBOARD.PRODUCT_HANDLING.PRODUCT_CODE" | translate }}</span>
                <app-input
                        id="product-code"
                        type="text"
                        placeholder=""
                        [formController]="productForm.controls.productCode"
                        [initialValue]="productForm.controls.productCode.value"
                />
                @if ( this.submitAction() && !productForm.controls.productCode.valid ) {
                    <span class="text-red-500">{{ "DASHBOARD.PRODUCT_HANDLING.PRODUCT_CODE_REQUIRED" | translate }}</span>
                }
            </label>

            <!-- ALATUOTE sisältöä ei ole vielä toteutettu
            <label for="sub-product" class="flex gap-2" >
                <span class="font-bold">Ala-tuote</span>
                <input id="sub-product" type="checkbox" #isSubProduct>
            </label>

            <label for="sub-product-space-count" class="flex gap-1">
                <span class="font-bold text-nowrap">Ala-tuotteiden määrä: </span>
                <input id="sub-product-space-count" type="number" class="w-fit">
            </label>
            -->

        </app-card-wrap>

        <app-card-wrap layout="col">

            <label for="product-type" class="flex flex-col space-x-4">
                <span class="font-bold">{{ "DASHBOARD.PRODUCT_HANDLING.PRODUCT_TYPE" | translate }}</span>
                <app-select
                        id="product-type"
                        [formController]="productForm.controls.productType"
                        [options]="productTypes"
                        [initialValue]="productForm.controls.productType.value"
                />
            </label>
            @if ( this.isNewProductType() ) {
                <label for="new-product-type" class="flex flex-col space-x-4">
                    <span class="font-bold">{{ "DASHBOARD.PRODUCT_HANDLING.NEW_PRODUCT_TYPE_IDENTIFIER" | translate }}</span>
                    <app-input
                            id="new-product-type"
                            type="string"
                            class="col-span-5"
                            placeholder=""
                            [formController]="productForm.controls.newProductType"
                    />
                </label>
            }

            <div class="space-x-4 space-y-1">

                <h4 class="font-bold">{{ "DASHBOARD.PRODUCT_HANDLING.NEW_PRODUCT_DIMENSIONS" | translate }}:</h4>

                @if ( productType() !== 'lamella' ) {
                    <label for="width" class="grid grid-cols-8">
                        <span class="col-span-3 font-bold text-sm">{{ "GLOBAL.WIDTH" | translate }}:</span>
                        <app-input id="width"
                                   type="number"
                                   class="col-span-5 text-sm"
                                   unit="mm"
                                   [inputPadding]="0"
                                   [formController]="productForm.controls.width"
                                   [initialValue]="productForm.controls.width.value"
                        />
                    </label>
                }

                <label for="height" class="grid grid-cols-8">
                    <span class="col-span-3 font-bold text-sm">{{ "GLOBAL.HEIGHT" | translate }}:</span>
                    <app-input id="height"
                               type="number"
                               class="col-span-5 text-sm"
                               unit="mm"
                               [inputPadding]="0"
                               [formController]="productForm.controls.height"
                               [initialValue]="productForm.controls.height.value"
                    />
                </label>

                <label for="depth" class="grid grid-cols-8">
                    <span class="col-span-3 font-bold text-sm">{{ "GLOBAL.DEPTH" | translate }}:</span>
                    <app-input id="depth"
                               type="number"
                               class="col-span-5 text-sm"
                               unit="mm"
                               [inputPadding]="0"
                               [formController]="productForm.controls.depth"
                               [initialValue]="productForm.controls.depth.value"
                    />
                </label>
            </div>

        </app-card-wrap>

        <app-card-wrap layout="col">

            <label for="product-url" class="flex flex-col space-x-4">
                <span class="font-bold">{{ "DASHBOARD.PRODUCT_HANDLING.PRODUCT_URL" | translate }}</span>
                <app-input id="product-url" type="text" [formController]="productForm.controls.url" />
            </label>

            <label for="cover-image" class="flex flex-col space-x-4">
                <span class="font-bold">{{ "DASHBOARD.PRODUCT_HANDLING.PRODUCT_IMAGE" | translate }}</span>
                <input id="cover-image" #coverImage type="file" (change)="handleFileLoad(coverImage.files, 'coverImageFile')">
            </label>

            <label for="measure-image" class="flex flex-col space-x-4">
                <span class="font-bold">{{ "DASHBOARD.PRODUCT_HANDLING.PRODUCT_MEASURE_IMAGE" | translate }}</span>
                <input id="measure-image" #measureImage type="file" (change)="handleFileLoad(measureImage.files, 'measureImageFile')">
            </label>

        </app-card-wrap>
    </div>

    <div class="bg-primary text-white p-4 font-bold">
        {{ "DASHBOARD.PRODUCT_HANDLING.PRODUCT_TYPE_SPECIFIC_SETTINGS" | translate }}
    </div>

    <div class="grid grid-cols-[repeat(auto-fit,minmax(20rem,2fr))] grid-flow-dense gap-4 p-4">
        <ng-container [ngTemplateOutlet]="productTypeConfigTemplate()" />
    </div>

    <div class="bg-primary text-white p-4 font-bold">
        {{ "DASHBOARD.PRODUCT_HANDLING.3D_MODEL_SETTINGS" | translate }}
    </div>

    <div class="flex flex-col gap-4 p-4">

        <app-card-wrap layout="grid" class="grid-cols-[repeat(auto-fill,minmax(20rem,1fr))]">

            @if (productForm.controls.model3d.length < 1){
                <input type="file" class="hidden" #model3dAdd (change)="handleModel3dLoad(model3dAdd.files)" />
                <div class="grid gap-4 p-4 text-center bg-white font-semibold ">

                    <button type="button" (click)="model3dAdd.click()" class="bg-secondary text-white first-letter:capitalize p-4" >
                        {{ "DASHBOARD.PRODUCT_HANDLING.NEW_3D_MODEL" | translate }}
                    </button>

                    <!-- TODO: valitse olemassa oleva malli
                    <app-select class="border h-full content-center bg-white hover:bg-slate-100 first-letter:capitalize" placeholder="olemassa oleva"> olemassa oleva</app-select>
                    -->

                </div>
            }

            @for( model3d of productForm.controls.model3d; track $index) {
                <div class="border">

                    <div class="bg-primary-950 text-white flex justify-between w-full font-semibold px-4">
                        <h4 class="">{{ model3d.controls.name.valueChanges | async }}</h4>
                        <button class="" (click)="handleModel3dRemove($index)">X</button>
                    </div>

                    <div class="p-4 space-y-2">

                        <label for="model-name" class="grid grid-cols-8 space-x-4">
                            <span class="font-bold col-span-2">{{ "GLOBAL.NAME" | translate }}: </span>
                            <app-input id="model-name" [inputPadding]="0" class="col-span-6" [formController]="model3d.controls.name" [initialValue]="model3d.value.name" [disabled]="model3d.controls.id.value !== undefined" />
                        </label>

                        <div>

                            @if (model3d.value.id){
                                <div class="flex justify-between text-slate-500 font-semibold text-sm">
                                    <span class="">
                                        ID:
                                    </span>
                                    <span>
                                        {{ model3d.value.id }}
                                    </span>
                                </div>
                            }

                            <div class="flex justify-between text-slate-500 font-semibold text-sm">
                                <span class="">
                                    {{ "GLOBAL.FILE_TYPE" | translate }}:
                                </span>
                                <span class="uppercase">
                                    .{{model3d.value.filetype}}
                                </span>
                            </div>
                        </div>

                        <label for="model-description" class="flex space-x-4">
                            <span class="font-bold">Selite: </span>
                            <textarea id="model-description" class="w-full border" [formControl]="model3d.controls.description"> </textarea>
                        </label>
                    </div>

                </div>
            }

        </app-card-wrap>
    </div>

    <div class="bg-primary text-white p-4 font-bold flex justify-between">

        <a (click)="clearCache()" [routerLink]="['..', {}]">
            <button class="bg-secondary text-white h-full p-3 flex gap-2 rounded-md" >
                <img src="assets/images/icons/arrow-left.svg" alt="" width="24" height="24"/>
                {{ "GLOBAL.RETURN" | translate }}
            </button>
        </a>

        <button type="submit"
                [disabled]="submitAction()"
                class="relative text-white p-2 rounded-md overflow-hidden flex items-center justify-center w-48" [class]="{'bg-gray-400': submitAction(), 'bg-secondary': !submitAction()}">
            <!-- Alkuperäinen tila: näytetään käännettävä teksti -->
            <span class="capitalize transition-all duration-300 overflow-hidden whitespace-nowrap w-full"
                  [class]="{ 'hidden': submitAction(), 'bg-gray-400': submitAction()}">
            {{ "GLOBAL.SAVE" | translate }}
          </span>

            <!-- Lataustila: aluksi piilotettu, sitten fade in -->
            <span class="absolute inset-0 flex items-center justify-center transition-opacity duration-300"
                  [class]="{ 'opacity-100': submitAction(), 'opacity-0': !submitAction() }">
            <!-- Latausindikaattori -->
            <svg class="animate-spin mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg"
                 fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>
            {{ "GLOBAL.SAVING_IN_PROGRESS" | translate }}
          </span>
        </button>

    </div>

</form>
<!-- lamellaConfigTemplate -->
<ng-template #lamellaTemplate let-form="form">

    <app-card-wrap layout="grid" class="">
        <div class="space-x-4 space-y-4">
            <h4 class="font-bold">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_LAYOUT' | translate }}</h4>

            <label for="lamella-installation-directions" class="grid grid-cols-8 items-center gap-2">
                <div class="col-span-4 flex-col gap-2">
                    <div class="font-bold text-sm text-nowrap">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_INSTALLATION_DIRECTION' | translate }}</div>
                    <div class=" text-sm text-gray-600 ">{{ 'DASHBOARD.PRODUCT_HANDLING.HELP.LAMELLA_INSTALLATION_DIRECTION' | translate }}</div>
                </div>
                <app-select id="lamella-installation-directions" class="col-span-4 text-sm"
                            [options]="installationDirections"
                            [formController]="productForm.controls.lamella?.controls.installationDirection"
                            [initialValue]="productForm.controls.lamella?.controls.installationDirection.value"
                />
            </label>

            <label for="space-taken" class="grid grid-cols-8 items-center gap-2">
                <div class="col-span-4 flex-col gap-2">
                    <div class="font-bold text-sm text-nowrap">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_SPACE_TAKEN' | translate }}</div>
                    <div class=" text-sm text-gray-600 ">{{ 'DASHBOARD.PRODUCT_HANDLING.HELP.LAMELLA_SPACE_TAKEN' | translate }}</div>
                </div>
                <app-select id="space-taken" type="number" class="col-span-4 text-sm"
                            [options]="lamelSpaces"
                            [formController]="productForm.controls.lamella?.controls.spaceTaken"
                            [initialValue]="productForm.controls.lamella?.controls.spaceTaken.value"
                />
            </label>

            <label for="min-space-top" class="grid grid-cols-8 items-center gap-2">
                <div class="col-span-4 flex-col gap-2">
                    <div class="font-bold text-sm text-nowrap">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_MIN_SPACE_TOP' | translate }}</div>
                    <div class=" text-sm text-gray-600 ">{{ 'DASHBOARD.PRODUCT_HANDLING.HELP.LAMELLA_MIN_SPACE_TOP' | translate }}</div>
                </div>
                <app-select id="min-space-top" type="number" class="col-span-4 text-sm"
                            [options]="lamelSpaces"
                            [formController]="productForm.controls.lamella?.controls.minSpaceTop"
                            [initialValue]="productForm.controls.lamella?.controls.minSpaceTop.value"
                />
            </label>

            <label for="min-space-bottom" class="grid grid-cols-8 items-center gap-2">
                <div class="col-span-4 flex-col gap-2">
                    <div class="font-bold text-sm text-nowrap">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_MIN_SPACE_BOT' | translate }}</div>
                    <div class=" text-sm text-gray-600 ">{{ 'DASHBOARD.PRODUCT_HANDLING.HELP.LAMELLA_MIN_SPACE_BOTTOM' | translate }}</div>
                </div>
                <app-select id="min-space-bottom" type="number" class="col-span-4 text-sm"
                            [options]="lamelSpaces"
                            [formController]="productForm.controls.lamella?.controls.minSpaceBottom"
                            [initialValue]="productForm.controls.lamella?.controls.minSpaceBottom.value"
                />
            </label>

            <label for="min-space" class="grid grid-cols-8 items-center gap-2">
                <div class="col-span-4 flex-col gap-2">
                    <div class="font-bold text-sm text-nowrap">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_MIN_SPACE' | translate }}</div>
                    <div class=" text-sm text-gray-600 ">{{ 'DASHBOARD.PRODUCT_HANDLING.HELP.LAMELLA_MIN_SPACE' | translate }}</div>
                </div>
                <app-select id="min-space" type="number" class="col-span-4 text-sm"
                            [options]="lamelSpaces"
                            [formController]="productForm.controls.lamella?.controls.minSpace"
                            [initialValue]="productForm.controls.lamella?.controls.minSpace.value"
                />
            </label>

            <label for="max-space" class="grid grid-cols-8 items-center gap-2">
                <div class="col-span-4 flex-col gap-2">
                    <span class="col-span-4 font-bold text-sm text-nowrap">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_MAX_SPACE' | translate }}</span>
                    <div class=" text-sm text-gray-600 ">{{ 'DASHBOARD.PRODUCT_HANDLING.HELP.LAMELLA_MAX_SPACE' | translate }}</div>
                </div>
                <app-select id="max-space" type="number" class="col-span-4 text-sm"
                            [options]="lamelSpaces"
                            [formController]="productForm.controls.lamella?.controls.maxSpace"
                            [initialValue]="productForm.controls.lamella?.controls.maxSpace.value"
                />
            </label>

            <label for="frame-max-span" class="grid grid-cols-8 items-center gap-2">
                <div class="col-span-4 flex-col gap-2">
                    <span class="col-span-4 font-bold text-sm text-nowrap">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_FRAME_MAX_SPAN' | translate }}</span>
                    <div class=" text-sm text-gray-600 ">{{ 'DASHBOARD.PRODUCT_HANDLING.HELP.LAMELLA_FRAME_MAX_SPAN' | translate }}</div>
                </div>
                <app-input id="frame-max-span" type="number" class="col-span-4 text-sm"
                            [formController]="productForm.controls.lamella?.controls.maxFrameSpan"
                            [initialValue]="productForm.controls.lamella?.controls.maxFrameSpan.value"
                />
            </label>
        </div>

        <!-- TODO: selite kuva

        <div>
            selite kuva
        </div>

        -->
    </app-card-wrap>

    <app-card-wrap layout="col" class="space-y-4">

        <!--
        <label for="lamella-name" class="flex flex-col space-x-4">
            <span class="font-bold">Lamellin nimi</span>
            <app-input id="lamella-name" type="text"/>
        </label>
        -->
        <label for="lamella-family" class="flex flex-col space-x-4">
            <span class="font-bold">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_PRODUCT_TYPE' | translate }}</span>
            <app-select
                    id="lamella-family"
                    [formController]="productForm.controls.lamella.controls.lamellaCategory"
                    [options]="lamellaFamilies"
                    [initialValue]="productForm.controls.lamella.controls.lamellaCategory.value"
            />
        </label>

        <div class="space-x-4">
            <h4 class="font-bold">{{ 'DASHBOARD.PRODUCT_HANDLING.lAMELLA_MOUNTING' | translate }}</h4>
            <label for="uses-fixplate" class="flex space-x-4">
                <input id="uses-fixplate" type="checkbox" [formControl]="productForm.controls.lamella?.controls.usesFixplate" />
                <span class="">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_FIXPLATE' | translate }}</span>
            </label>
            <label for="uses-locking-screw" class="flex space-x-4">
                <input id="uses-locking-screw" type="checkbox" [formControl]="productForm.controls.lamella?.controls.usesLockingScrew" />
                <span class="">{{ 'DASHBOARD.PRODUCT_HANDLING.LAMELLA_LOCKING_SCREW' | translate }}</span>
            </label>
        </div>

    </app-card-wrap>
</ng-template>


<!-- no type specific template -->
<ng-template #newProductTypeTemplate let-form="form">

    <app-card-wrap layout="col" class="text-slate-400">
        {{ 'DASHBOARD.PRODUCT_HANDLING.NO_SETTINGS_PROVIDED' | translate }}
    </app-card-wrap>

</ng-template>
